/*
 * Search as you type for the customer websites and the webapp (design-independent; the templates style it through
 * the --ss-* custom properties, see /css/site-search.css).
 *
 * Markup: <form data-site-search [data-site-search-app="1"]> … <input type="search"> … </form>
 * The form keeps working without JavaScript (its own submit goes to the result page). With it:
 * - suggestions 250 ms after the last keystroke (debounced), from 2 characters, the previous request is aborted,
 *   answers are remembered for the page's lifetime, the same query is never asked twice in a row
 * - ARIA combobox: ↓/↑ move, Enter opens the active suggestion (else the result page), Esc closes, then clears
 * - suggestions are real links: Cmd/Ctrl-click, middle click, Cmd/Ctrl+Enter open a new tab
 * - „Direkt zu“ links (Kontakt for „Anfahrt“ …), the best hits with their group, „Alle n Ergebnisse“
 * - spelling: nothing as typed → hits for the corrected words, said so in the list
 */
(function () {
  'use strict';
  if (!window.fetch || !document.querySelector) { return; }

  var DELAY = 250;
  var MIN = 2;
  var T = {
    de: { direct: 'Direkt zu', all: 'Alle {n} Ergebnisse anzeigen', allOne: 'Ergebnis anzeigen', none: 'Keine Vorschläge – Enter sucht trotzdem.',
      fixed: 'Ergebnisse für „{q}“', count: '{n} Vorschläge', label: 'Vorschläge' },
    en: { direct: 'Go to', all: 'Show all {n} results', allOne: 'Show result', none: 'No suggestions – press Enter to search anyway.',
      fixed: 'Results for “{q}”', count: '{n} suggestions', label: 'Suggestions' },
    pl: { direct: 'Przejdź do', all: 'Pokaż wszystkie wyniki ({n})', allOne: 'Pokaż wynik', none: 'Brak podpowiedzi – Enter i tak wyszuka.',
      fixed: 'Wyniki dla „{q}”', count: 'Podpowiedzi: {n}', label: 'Podpowiedzi' }
  };
  var lang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var t = T[lang] || T.de;
  // context path: from this script's own URL (…/js/site-search.js)
  var me = document.currentScript;
  var ctx = me && /** @type {HTMLScriptElement} */ (me).src ? /** @type {HTMLScriptElement} */ (me).src.replace(/^https?:\/\/[^/]+/, '').replace(/\/js\/site-search\.js.*$/, '') : '';
  var seq = 0;

  function css() {
    if (document.getElementById('ss-css')) { return; }
    var l = document.createElement('link');
    l.id = 'ss-css';
    l.rel = 'stylesheet';
    l.href = ctx + '/css/min/site-search.css?v=6'; // compressed build (batch 2, RC78 S row 31); v=6 RC91 J2 (scroll lock, list fit, pinned „Alle“ row)
    document.head.appendChild(l);
  }

  function fmt(s, o) {
    return s.replace(/\{(\w+)\}/g, function (m, k) { return o[k] == null ? '' : o[k]; });
  }

  function text(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function init(form) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input || form.getAttribute('data-ss-ready')) { return; }
    form.setAttribute('data-ss-ready', '1');
    form.classList.add('ss');
    var app = form.getAttribute('data-site-search-app') === '1';
    // webapp on the main domain: the host names no customer, the page does
    var schule = app ? form.getAttribute('data-site-search-schule') || '' : '';
    var appBase = app ? form.getAttribute('data-site-search-base') || '' : '';
    var n = ++seq;
    var list = document.createElement('div');
    list.className = 'ss-list';
    list.id = 'ss-list-' + n;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', t.label);
    list.hidden = true;
    var status = document.createElement('div');
    status.className = 'ss-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    (input.parentNode || form).appendChild(list);
    form.appendChild(status);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('autocomplete', 'off');

    var cache = {};
    var timer = null;
    var ctrl = null;
    var last = null;
    var options = [];
    var active = -1;

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function setActive(i) {
      if (!options.length) { return; }
      active = (i + options.length) % options.length;
      for (var k = 0; k < options.length; k++) {
        options[k].setAttribute('aria-selected', k === active ? 'true' : 'false');
      }
      input.setAttribute('aria-activedescendant', options[active].id);
      if (options[active].scrollIntoView) { options[active].scrollIntoView({ block: 'nearest' }); }
    }

    function option(url, html, cls) {
      var a = document.createElement('a');
      a.href = url;
      a.className = 'ss-opt' + (cls ? ' ' + cls : '');
      a.id = list.id + '-' + options.length;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      a.tabIndex = -1;
      a.innerHTML = html; // server sends escaped text with <mark> only; labels go through text()
      options.push(a);
      return a;
    }

    function render(d) {
      list.innerHTML = '';
      options = [];
      active = -1;
      if (d.corrected) {
        var c = document.createElement('div');
        c.className = 'ss-note';
        c.textContent = fmt(t.fixed, { q: d.corrected });
        list.appendChild(c);
      }
      (d.links || []).forEach(function (l) {
        list.appendChild(option(l.url, '<span class="ss-group">' + text(t.direct) + '</span><span class="ss-title">' + text(l.label) + '</span>', 'ss-opt--direct'));
      });
      (d.hits || []).forEach(function (h) {
        list.appendChild(option(h.url, '<span class="ss-group">' + text(h.group) + '</span><span class="ss-title">' + h.title + '</span>'));
      });
      if (d.all && d.total > 0) {
        list.appendChild(option(d.all, '<span class="ss-title">' + text(d.total === 1 ? t.allOne : fmt(t.all, { n: d.total })) + '</span>', 'ss-opt--all'));
      }
      if (!options.length) {
        var e = document.createElement('div');
        e.className = 'ss-note';
        e.textContent = t.none;
        list.appendChild(e);
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      status.textContent = fmt(t.count, { n: (d.links || []).length + (d.hits || []).length });
    }

    function ask(q) {
      if (q === last) { list.hidden = !list.children.length; input.setAttribute('aria-expanded', String(!list.hidden)); return; }
      last = q;
      if (cache[q]) { render(cache[q]); return; }
      if (ctrl) { ctrl.abort(); }
      ctrl = window.AbortController ? new AbortController() : null;
      var url = ctx + '/suche-api/vorschlaege/?q=' + encodeURIComponent(q) + '&lang=' + encodeURIComponent(lang) + (app ? '&app=1' : '') + (/^\d+$/.test(schule) ? '&s=' + schule + '&base=' + encodeURIComponent(appBase) : '');
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) { return; }
          cache[q] = d;
          if (input.value.trim() === q) { render(d); }
        })
        .catch(function () { /* aborted or offline: the form still submits to the result page */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < MIN) {
        if (ctrl) { ctrl.abort(); }
        last = null;
        close();
        return;
      }
      timer = setTimeout(function () { ask(q); }, DELAY);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        if (list.hidden && options.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
        setActive(active + 1);
        e.preventDefault();
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        setActive(active - 1);
        e.preventDefault();
      } else if (e.key === 'Enter' && !list.hidden && active >= 0) {
        e.preventDefault();
        e.stopPropagation();
        if (e.metaKey || e.ctrlKey || e.shiftKey) {
          // like a modified click on the link: new tab (Cmd/Ctrl) or new window (Shift), the list stays
          window.open(options[active].href, '_blank', e.shiftKey ? 'noopener,popup' : 'noopener');
        } else {
          window.location.href = options[active].href;
        }
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        if (!list.hidden) {
          var marked = !!input.getAttribute('aria-activedescendant');
          close();
          // inside a header toggle panel an Esc without a marked suggestion goes on and closes the panel too (one key dismisses the
          // search); with a suggestion marked it first steps back to the field. An expand-mode overlay (data-ss-expand, RC57 O2)
          // is layered: the first Esc closes only the list, the next one the overlay.
          if (!form.closest('[data-ss-panel]') || form.closest('[data-ss-expand]') || marked) { e.preventDefault(); e.stopPropagation(); }
        } else if (input.value && !form.closest('[data-ss-panel]')) { input.value = ''; e.preventDefault(); } // a header panel (toggle or expand overlay) closes and keeps the text: list, then panel = 2 presses
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && options.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });
    // pointer: keep focus in the field until the link is followed
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) { close(); } });
    form.addEventListener('focusout', function (e) { if (!form.contains(e.relatedTarget)) { close(); } });
  }

  /*
   * Header toggle: <button data-site-search-toggle aria-controls="panel-id" aria-expanded="false"> opens the panel
   * (hidden attribute) and focuses its field; Esc in the panel or a click outside closes it, focus returns.
   *
   * Opt-in expand mode (RC57 O2): a panel with data-ss-expand is an overlay inside the header bar that slides open from
   * the toggle (class ss-expand--open, transition in /css/site-search.css); it gets hidden again after the closing
   * transition (at once with reduced motion). In this mode a [data-ss-close] button inside closes it (focus back to the
   * toggle), and focus moving to anything outside the panel closes it without moving the focus (the overlay covers
   * the bar, a covered link must never hold the focus). Panels without the attribute behave as before.
   */
  // focus without scrolling the page (an engine without the preventScroll option gets its old scroll position back)
  function focusInPlace(el) {
    var x = window.scrollX, y = window.scrollY;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    if (window.scrollX !== x || window.scrollY !== y) { jumpTo(x, y); }
  }
  // scroll back without the template's smooth scrolling (atelier: html scroll-behavior smooth) – an animated restore is a jump
  function jumpTo(x, y) {
    var st = document.documentElement.style, b = st.scrollBehavior;
    st.scrollBehavior = 'auto';
    window.scrollTo(x, y);
    st.scrollBehavior = b;
  }
  // phone/tablet width: the open expanding search locks the page (lock() in toggle(); the same breakpoint in site-search.scss)
  var PHONE = '(max-width: 1079.98px)';

  function toggle(btn) {
    if (btn.getAttribute('data-ss-ready')) { return; }
    btn.setAttribute('data-ss-ready', '1');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) { return; }
    panel.setAttribute('data-ss-panel', '1');
    var expand = panel.hasAttribute('data-ss-expand');
    // RC89 (search-close-position): the header of an expanding search carries data-ss-open while it is open, so the template's menu
    // entries under the field are hidden (site-search.css) instead of showing cut off or faded
    var host = expand ? btn.closest('header') : null;
    if (host) { host.setAttribute('data-ss-host', ''); }
    var timer = 0;
    function isOpen() { return expand ? btn.getAttribute('aria-expanded') === 'true' : !panel.hidden; }
    function hideLater() {
      var d = parseFloat(getComputedStyle(panel).transitionDuration) || 0;
      if (!d || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) { panel.hidden = true; return; }
      // transitionend can be missed (tab in the background, property not animated): the timer is the fallback
      timer = setTimeout(function () { if (!isOpen()) { panel.hidden = true; } }, d * 1000 + 60);
    }
    function show(open) {
      clearTimeout(timer);
      if (!expand) { panel.hidden = !open; return; }
      if (open) {
        panel.hidden = false;
        void panel.offsetWidth; // start the transition from the closed state
        panel.classList.add('ss-expand--open');
      } else {
        panel.classList.remove('ss-expand--open');
        hideLater();
      }
    }
    // RC91 J2 (jrk-mobile-search-bounce, owner on a real iPhone): below 1080 px the open search locks the page instead of following
    // the visual viewport – iOS paints the scrolled frame before the visualViewport scroll event, so a header moved after the fact
    // went down with the page and snapped back (flicker). Locked: html overflow hidden (site-search.css, :root[data-ss-search] in the
    // same media query), a one-finger touchmove outside a scrollable suggestion list is cancelled (iOS < 16 ignores overflow on the
    // root; pinch zoom stays), the list gets the height left in the visual viewport (--ss-fit) and scrolls inside. scrollY never
    // changes, so nothing jumps on open; on close an engine that moved it anyway (focus reveal) gets the exact position back.
    var vv = host ? window.visualViewport : null;
    var lockAt = null;
    function phone() { return !!(window.matchMedia && window.matchMedia(PHONE).matches); }
    function guard(e) {
      if (e.touches && e.touches.length > 1) { return; }
      var t = /** @type {Element} */ (e.target);
      var l = t && t.closest ? t.closest('.ss-list') : null;
      if (l && l.scrollHeight > l.clientHeight) { return; }
      if (t && t.closest && t.closest('input')) { return; }
      if (e.cancelable) { e.preventDefault(); }
    }
    function fit() {
      var l = /** @type {HTMLElement} */ (panel.querySelector('.ss-list'));
      var f = panel.querySelector('input[type="search"], input[name="q"]');
      if (!l || !f) { return; }
      var bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      l.style.setProperty('--ss-fit', Math.max(120, Math.floor(bottom - f.getBoundingClientRect().bottom - 18)) + 'px');
    }
    function lock(on) {
      var m = on ? 'addEventListener' : 'removeEventListener';
      if (on ? lockAt || !phone() : !lockAt) { return; }
      document[m]('touchmove', guard, { passive: false });
      window[m]('resize', fit);
      if (vv) { vv[m]('resize', fit); }
      if (on) {
        lockAt = [window.scrollX, window.scrollY];
        fit();
      } else {
        var l = /** @type {HTMLElement} */ (panel.querySelector('.ss-list'));
        if (l) { l.style.removeProperty('--ss-fit'); }
        if (window.scrollX !== lockAt[0] || window.scrollY !== lockAt[1]) { jumpTo(lockAt[0], lockAt[1]); }
        lockAt = null;
      }
    }
    function set(open, focusBack) {
      btn.setAttribute('aria-expanded', String(open));
      if (host) {
        if (open) { host.setAttribute('data-ss-open', ''); } else { host.removeAttribute('data-ss-open'); }
        // RC91: the page's scroll-padding-top keeps focused content clear of the sticky bar – measured against it, the field IN the bar
        // always looks covered, so every caret reveal while typing (WebKit/iOS) and every suggestion scrollIntoView scrolled the page up
        // (900 → 702 px after three letters); while the search is open the padding is off (site-search.css, :root[data-ss-search])
        if (open) { document.documentElement.setAttribute('data-ss-search', ''); } else { document.documentElement.removeAttribute('data-ss-search'); }
      }
      show(open);
      if (host) { lock(open); }
      if (open) {
        var f = panel.querySelector('input[type="search"], input[name="q"]');
        // RC91: no scroll on open – the field is already in view in the bar, but the focus scroll measured it against the page's
        // scroll-padding-top (the bar's own height) and smooth-scrolled the page towards the top (WebKit and Chrome, 900 → 558 / 0 px)
        if (f) { focusInPlace(/** @type {HTMLElement} */ (f)); }
      } else if (focusBack) {
        // RC91 J2: the magnifier sits in the sticky bar, so the page's scroll-padding-top (back on now) made a plain focus scroll the
        // page up (Esc/close: 900 → 470 px); it is in view already
        focusInPlace(btn);
      }
    }
    btn.addEventListener('click', function (e) {
      // a link toggle (no-JS fallback to /suche/) must not navigate once the panel exists – except a modified or middle click, which
      // opens /suche/ in a new tab/window as usual
      if (btn.tagName === 'A') {
        if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) { return; }
        e.preventDefault();
      }
      set(!isOpen(), false);
    });
    // role=button on a link: Space toggles like Enter (Enter already fires click)
    if (btn.tagName === 'A') {
      btn.addEventListener('keydown', function (e) {
        if ((e.key === ' ' || e.key === 'Spacebar') && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) { e.preventDefault(); set(!isOpen(), false); }
      });
    }
    panel.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !e.defaultPrevented) {
        var list = panel.querySelector('.ss-list');
        if (!list || /** @type {HTMLElement} */ (list).hidden) { set(false, true); }
      }
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !panel.contains(/** @type {Node} */ (e.target)) && !btn.contains(/** @type {Node} */ (e.target))) { set(false, false); }
    });
    if (expand) {
      var close = panel.querySelector('[data-ss-close]');
      if (close) { close.addEventListener('click', function () { set(false, true); }); }
      panel.addEventListener('focusout', function (e) {
        if (isOpen() && e.relatedTarget && !panel.contains(/** @type {Node} */ (e.relatedTarget))) { set(false, false); }
      });
      panel.addEventListener('transitionend', function (e) {
        if (e.target === panel && !isOpen()) { clearTimeout(timer); panel.hidden = true; }
      });
    }
  }

  function scan() {
    var forms = document.querySelectorAll('form[data-site-search]');
    if (forms.length) { css(); }
    for (var i = 0; i < forms.length; i++) { init(forms[i]); }
    var toggles = document.querySelectorAll('[data-site-search-toggle]');
    for (var k = 0; k < toggles.length; k++) { toggle(toggles[k]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  // pages that add or replace their body late (webapp shell): set up on load and, at the latest, when a field
  // of such a form gets the focus – init() skips what is set up already
  window.addEventListener('load', scan);
  document.addEventListener('focusin', function (e) {
    var f = e.target && /** @type {Element} */ (e.target).closest ? /** @type {Element} */ (e.target).closest('form[data-site-search]') : null;
    if (f) { css(); init(f); }
  });
  window.SiteSearch = { scan: scan };
})();
